import { useState, useEffect } from 'react';
import { getFields } from '../services/apiService';

const useUserOnboardingStatus = () => {
  const [hasFields, setHasFields] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkFields = async () => {
      try {
        const fields = await getFields();
        setHasFields(fields && fields.length > 0);
      } catch (err) {
        console.error('Failed to fetch user fields:', err);
        setError(err);
        setHasFields(false); // Assume no fields if there's an error
      } finally {
        setLoading(false);
      }
    };

    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (userInfo && userInfo.role !== 'ADMIN') {
      checkFields();
    } else {
      setLoading(false);
    }
  }, []); // Run once on component mount

  return { hasFields, loading, error };
};

export default useUserOnboardingStatus;
